var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilm03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "film-03",
    clipPath: "url(#clip0_2245_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.83317 1.66675V5.00008M5.83317 13.3334V16.6667M14.1665 3.33341V6.66675M14.1665 15.0001V18.3334M1.6665 5.00008H9.99984M1.6665 13.3334H9.99984M9.99984 6.66675H18.3332M9.99984 15.0001H18.3332M9.99984 16.6667V3.00008C9.99984 2.53337 9.99984 2.30002 9.90901 2.12176C9.82912 1.96495 9.70163 1.83747 9.54483 1.75758C9.36657 1.66675 9.13321 1.66675 8.6665 1.66675H5.6665C4.26637 1.66675 3.56631 1.66675 3.03153 1.93923C2.56112 2.17892 2.17867 2.56137 1.93899 3.03177C1.6665 3.56655 1.6665 4.26662 1.6665 5.66675V12.6667C1.6665 14.0669 1.6665 14.7669 1.93899 15.3017C2.17867 15.7721 2.56112 16.1546 3.03153 16.3943C3.56631 16.6667 4.26637 16.6667 5.6665 16.6667H9.99984ZM9.99984 3.33341H14.3332C15.7333 3.33341 16.4334 3.33341 16.9681 3.6059C17.4386 3.84558 17.821 4.22803 18.0607 4.69844C18.3332 5.23322 18.3332 5.93328 18.3332 7.33342V14.3334C18.3332 15.7335 18.3332 16.4336 18.0607 16.9684C17.821 17.4388 17.4386 17.8212 16.9681 18.0609C16.4334 18.3334 15.7333 18.3334 14.3332 18.3334H11.3332C10.8665 18.3334 10.6331 18.3334 10.4548 18.2426C10.298 18.1627 10.1706 18.0352 10.0907 17.8784C9.99984 17.7001 9.99984 17.4668 9.99984 17.0001V3.33341Z",
    stroke: "#FFB74B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2245_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm03);
export default __webpack_public_path__ + "static/media/film-03.8e0ad0d5293b115eecfb5a73b3e469e9.svg";
export { ForwardRef as ReactComponent };